import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface MonoLabelProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'mute' | 'faint' | 'ink' | 'acc' | 'up' | 'down';
  size?: 'sm' | 'md';
}

const TONE = {
  mute: 'text-mute',
  faint: 'text-faint',
  ink: 'text-ink',
  acc: 'text-acc',
  up: 'text-up',
  down: 'text-down',
} satisfies Record<NonNullable<MonoLabelProps['tone']>, string>;

/** Uppercase mono metadata: eyebrows, table headers, statuses, counts. */
export function MonoLabel({ tone = 'faint', size = 'sm', className, ...props }: MonoLabelProps) {
  return (
    <span
      className={cn(
        'font-mono uppercase',
        size === 'sm' ? 'text-[10px] tracking-[0.14em]' : 'text-[11px] tracking-[0.16em]',
        TONE[tone],
        className
      )}
      {...props}
    />
  );
}
